import React from 'react'
import styled from 'styled-components'
import { Block } from '../block/block'
import { RadioContext } from './radio.context'

export const RadioGroup = ({
  disabled = false,
  onChange,
  value,
  children,
  initialValue,
  ...rest
}) => {
  const [currentValue, setCurrentValue] = React.useState(initialValue)
  const providerValue = React.useMemo(() => {
    return {
      updateState,
      disabledAll: disabled,
      inGroup: true,
      value: currentValue
    }
  }, [disabled, currentValue])

  React.useEffect(() => {
    if (value === undefined) return
    setCurrentValue(value)
  }, [value])

  function updateState(nextValue) {
    setCurrentValue(nextValue)
    onChange?.(nextValue)
  }

  return (
    <RadioContext.Provider value={providerValue}>
      <StyledRadioGroup role='radiogroup' gap={12} {...rest}>
        {children}
      </StyledRadioGroup>
    </RadioContext.Provider>
  )
}

const StyledRadioGroup = styled(Block)``
